import cx from 'classnames'
import * as React from 'react'

import CarouselDesktop from '../../components/CarouselDesktop/CarouselDesktop'
import DividerComp from '../../components/DividerComp/DividerComp'
import type { CarouselCardViewModel } from '../../view-models/CarouselCardViewModel'
import styles from './karrusel-style.css'

type Props = {
  items: Array<CarouselCardViewModel>
  useAsHeader?: boolean
  autoplay?: boolean
  hasDivider?: boolean
  autoplaySpeed?: number
}
type State = {}

class Karrusel extends React.Component<Props, State> {
  static displayName = 'Karrusel'
  static defaultProps = {}

  render() {
    const { items, useAsHeader, autoplay, autoplaySpeed, hasDivider } = this.props

    return (
      <div className={cx(styles.karrusel, 'karrusel')}>
        <CarouselDesktop
          items={items}
          autoplay={autoplay}
          autoplaySpeed={autoplaySpeed}
          useAsHeader={useAsHeader}
        />
        { hasDivider ? <DividerComp showOnDesktop/> : null }
      </div>
    )
  }
}

export default Karrusel